import historyEn from '../../views/history/lan/en'
import overviewEn from '../../views/overview/lan/en'


let locales = {};

locales = { ...locales, ...historyEn, ...overviewEn };


export default locales;